import React from 'react';
import logobiz from 'assets/img/biz-capital-logo-2019.png';
import Footer from '../footer/footer';
import { BizonSteps } from 'components/commons';
import { PartnerLogo } from '../header/layouts';
import { ProfileConsumer } from 'providers/profile.provider';
import './bizon-checkout-wrapper.styles.scss';

const BizonPartnerLogo: React.FC = (): JSX.Element => (
    <ProfileConsumer>
        {({ isPartner, logo }) => (
            isPartner !== true
                ? <img src={logobiz} alt="bizcap-logo" />
                : <PartnerLogo url={logo} />
        )}
    </ProfileConsumer>
);

const BizonCheckoutWrapper: React.FC = ({ children }): JSX.Element => {
    return (
        <>
            <div className="bizon-checkout-wrapper">
                <div className="bizon-checkout-wrapper__left-fill" />
                <div className="bizon-checkout-wrapper__middle">
                    <div className="bizon-checkout-wrapper__header grid-container">
                        <div className="bizon-checkout-wrapper__logo">
                            <BizonPartnerLogo />
                        </div>
                        <div className="bizon-checkout-wrapper__steps">
                            <BizonSteps />
                        </div>
                    </div>
                    <div className="bizon-checkout-wrapper__content">
                        {children}
                    </div>
                </div>
                <div className="bizon-checkout-wrapper__right-fill">
                    <div className="bizon-checkout-wrapper__right-fill--footer" />
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BizonCheckoutWrapper;
